import http from 'plugins/axios';

export default {
 
  delOne(id){
    return http.get({
      url:`/la/admin/blockHeightTask/del?id=${id}`
    })
  },
  updatInfo(blockHeightTaskDto){
    return http.post({
      url:`/la/admin/blockHeightTask/update`,
      data:{...blockHeightTaskDto}
    })
  },
  getBlockHeightTask({page,size,coinType,height,executionStatus}){
    return http.get({
      url:`/la/admin/blockHeightTask/list?page=${page}&size=${size}&coinType=${coinType}&height=${height}&executionStatus=${executionStatus}`
    })
  },
  getCountData(){
    return http.get({
      url:'/la/admin/blockHeightTask/countData'
    })
  }
};
